<template>
    <div class="submission-summary">
        <div class="pastime-notification" id="pastimeNotification">
            <i class="ecom-sucess"/>
            <div class="content">
                <h5 class="notification-title"> {{ kStrings.kPASTIME_REGISTRATION_SENT }} </h5>
                <p class="notification-description"> {{ kStrings.kPASTIME_REGISTRATION_SENT_DESC }} </p>
            </div>
        </div>
        <div class="summary-content themed-scrollbar" id="summaryContent">
            <div class="summary-participant">
                <h4 class="input-title"> {{ kStrings.kPASTIME_CONTESTANT_INFO }} </h4>
                <p class="info-line"> <span class="field-desc"> {{ kStrings.kGLOB_NAME + ':' }} </span> {{ summaryData.name }} </p>
                <p class="info-line"> <span class="field-desc"> {{ kStrings.kCOUNTRY + ':' }} </span> {{ summaryData.country }} </p>
                <p v-if="summaryData.social.link" class="info-line"> <span class="field-desc"> {{ kStrings.kPERSONAL_PAGE }} </span> {{ summaryData.social.link }} </p>
                <div class="contest-description">
                    <h4 v-if="summaryData.content" class="input-title"> {{ detailsTitle }} </h4>
                    <div v-if="summaryData.content" class="w-100">
                        <p v-if="summaryData.content.title" class="info-line"> <span class="field-desc"> {{ kStrings.kGLOB_TITLE + ':' }} </span> {{ summaryData.content.title }} </p>
                        <p v-if="summaryData.content.name" class="info-line"> <span class="field-desc"> {{ kStrings.kRECIPE_NAME + ':' }} </span> {{ summaryData.content.name }} </p>
                        <p v-if="summaryData.content.description" class="info-line"> <span class="field-desc"> {{ kStrings.kGLOB_TEXT_BODY + ':' }} </span>  {{ summaryData.content.description }} </p>
                        <p v-if="summaryData.content.preparationTime" class="info-line"> <span class="field-desc"> {{ kStrings.kRECIPE_TIME_PREP + ':' }} </span>  {{ summaryData.content.preparationTime }} </p>
                        <p v-if="summaryData.content.cookingTime" class="info-line"> <span class="field-desc"> {{ kStrings.kRECIPE_TIME_COOKING + ':' }} </span>  {{ summaryData.content.cookingTime }} </p>
                        
                        <h4 v-if="summaryData.content.ingredientList" class="input-title mt-2"> {{ kStrings.kRECIPE_INGREDIENTS + ':' }} </h4>
                        <p v-if="summaryData.content.ingredientList" v-for="(ingredient, index) in summaryData.content.ingredientList" class="info-line list-line"> {{ ingredient.value }} </p>
    
                        <h4 v-if="summaryData.content.preparationStepsList" class="input-title mt-2"> {{ kStrings.kRECIPE_MODE_PREP + ':' }} </h4>
                        <p v-if="summaryData.content.preparationStepsList" v-for="(step, index) in summaryData.content.preparationStepsList" class="info-line list-line"> <span class="field-desc"> {{ index + 1 + 'º ' +  kStrings.kGLOB_STEP + ': ' }} </span> {{ step.value }} </p>
                        
                        <p v-if="summaryData.content.observations" class="info-line"> <span class="field-desc"> {{ kStrings.kOBSERVATIONS + ':' }} </span>  {{ summaryData.content.observations }} </p>
                    </div>
                </div>
                <div v-if="summaryData.productList" class="saved-list-container" :class="{ 'has-items' : summaryData.productList.length }">
                    <div class="contest-description">
                        <h4 class="input-title"> {{ kStrings.kUSED_PRODUCTS + ':' }} </h4>
                    </div>
                    <div class="product-shop-list themed-scrollbar">
                        <div v-for="item in summaryData.productList" class="shop-item" :id="'shop-item-' + item.groupId">
                            <img :src="item.img" class="item-img" :alt="item.name"/>
                            <div class="mx-0 item-info-container">
                                <div class="prod-labels">
                                    <p class="item-label name-label"> {{ item.name }} </p>
                                    <p class="item-label light variant-label"> {{ item.label }} </p>
                                </div>
                                <div class="mt-auto action-labels">
                                    <p class="item-label light qty-label"> {{ kStrings.kQUANTITY + ': ' }} <span> {{ item.quantity ? item.quantity : 1 }} </span> </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="participantListPageLink" class="button-wrapper">
            <button class="pastime-button" @click.prevent="goToLink(participantListPageLink)"> {{ kStrings.kSHOW_PARTICIPANTS }} </button>
        </div>
        <div v-if="personalPageLink" class="button-wrapper">
            <button class="pastime-button light" @click.prevent="goToLink(participantListPageLink)"> <i class="ecom-link"/> </button>
        </div>
    </div>
</template>

<script>

import {store} from '@/store/pastimes';
import {isEmpty} from 'lodash-es';
import sharedApi from '@/api/sharedApi';

export default {
    store,
    name: 'FormSummary',
    components: {},
    props: {
        summaryData: {type: Object, default: null, required: true}
    },
    data() {
        return {}
    },
    computed: {
        kStrings() {
            return this.$store.getters.kStrings;
        },
        pastimeInfo() {
            return this.$store.getters.pastimeInfo;
        },
        isTypeRecipe() {
            return this.pastimeInfo.detailedInfo.isRecipe;
        },
        detailsTitle() {
            return this.isTypeRecipe ? this.kStrings.kRECIPE_INFORMATION + ':' : this.kStrings.kPARTICIPATION_DETAILS + ':'
        },
        participantListPageLink() {
            if(!this.summaryData.participantListPageLink) {
                return '';
            }
            
            return this.summaryData.participantListPageLink;
        },
        personalPageLink() {
            if(!this.summaryData.personalPageLink) {
                return '';
            }

            return this.summaryData.personalPageLink;
        }
    },
    watch: {},
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            sharedApi.debug('summary data: ', this.summaryData);
        });
    },
    methods: {
        goToLink(link) { // go to sharedApi?
            if(link) {
                window.location.assign(link);
            }
        }
    }
};
</script>

<style scoped>

</style>